

export class AlertGroupSelectAllOutputData implements IAlertGroupSelectAllOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id!: number;
    /** The user company name with 255 character limit */
    company_name!: string;
    /** The alert group name with 255 character limit */
    alert_group_name!: string;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    sunday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    monday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    tuesday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    wednesday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    thursday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    friday!: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    saturday!: number;
    /** The alert from time with 10 character limit */
    from_time!: string;
    /** The alert to time with 10 character limit */
    to_time!: string;
    /** The time zone with 255 character limit */
    time_zone!: string;
    /** Manage status of alert group. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IAlertGroupSelectAllOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alert_group_id = _data["alert_group_id"];
            this.company_name = _data["company_name"];
            this.alert_group_name = _data["alert_group_name"];
            this.sunday = _data["sunday"];
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.from_time = _data["from_time"];
            this.to_time = _data["to_time"];
            this.time_zone = _data["time_zone"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AlertGroupSelectAllOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGroupSelectAllOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alert_group_id"] = this.alert_group_id;
        data["company_name"] = this.company_name;
        data["alert_group_name"] = this.alert_group_name;
        data["sunday"] = this.sunday;
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["from_time"] = this.from_time;
        data["to_time"] = this.to_time;
        data["time_zone"] = this.time_zone;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAlertGroupSelectAllOutputData {
    /** The auto-generated id of the alert group master */
    alert_group_id: number;
    /** The user company name with 255 character limit */
    company_name: string;
    /** The alert group name with 255 character limit */
    alert_group_name: string;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    sunday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    monday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    tuesday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    wednesday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    thursday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    friday: number;
    /** The activation for alert group day wise 0 for unselected, 1 for selected */
    saturday: number;
    /** The alert from time with 10 character limit */
    from_time: string;
    /** The alert to time with 10 character limit */
    to_time: string;
    /** The time zone with 255 character limit */
    time_zone: string;
    /** Manage status of alert group. 0 For De-active, 1 For Active */
    status: number;
}

